import { render, staticRenderFns } from "./history-sensor.vue?vue&type=template&id=b65ff898&scoped=true"
import script from "./history-sensor.vue?vue&type=script&lang=js"
export * from "./history-sensor.vue?vue&type=script&lang=js"
import style0 from "./history-sensor.vue?vue&type=style&index=0&id=b65ff898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ff898",
  null
  
)

export default component.exports